export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-rdio-2eb1dc28faa47cdbc47045461298d8a3.svg";